import { ScreeningOrderSummaryDto } from '@inosio/payments-sdk';
import React, { CSSProperties } from 'react';
import { Box, Card, Grid, List, Modal, Stack, Tooltip, Typography } from '@mui/material';
import CancelIcon from '../../../icons/close.svg';
import ReviewOtpIcon from '../../../icons/ReviewOtpIcon.svg';
import { useHistory } from 'react-router';

type OrderScreeningListModalProps = {
  applicantName?: string
  applicantScreeningOrders: ScreeningOrderSummaryDto[];
  open: boolean;
  onClose: () => void;
  applicationUuid: string
  appDetailsSummaryState?: {
    returnQueryString: string;
    returnPage?: string
  };
};

export const OrderScreeningListModal: React.FC<OrderScreeningListModalProps> = ({ applicantName,open, onClose, applicantScreeningOrders, applicationUuid, appDetailsSummaryState }) => {
  const history = useHistory();
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '24px',
    height: '523px',
    pointerEvents: 'auto',
    width: '472px',
    borderRadius: '24px',
  };



  const renderScreeningProductItem = (screeningOrder: ScreeningOrderSummaryDto) => {
    const productsInfo = screeningOrder.Products;

    return productsInfo.map((product) => {

      const cursorPointerStyle : CSSProperties = {
        cursor: "pointer"
      }

      return (
        <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction={'row'}
        sx={{ flexWrap: 'wrap' }}
        key={product.Uuid}
      >
        <Box
          display="flex"
          alignItems="center"
          sx={{ cursor: 'pointer', marginBottom: '10px' }}
          onClick={() => {
            history.push(`/pmui/applications/${applicationUuid}/screening/${screeningOrder.ScreeningOrderUuid}`, {
              returnQueryString: appDetailsSummaryState?.returnQueryString || '',
            });
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Work Sans !important',
              fontStyle: 'normal',
              fontSize: '15px !important',
              lineHeight: '21px !important',
              color: '#14142B',
            }}
          >
            {product?.Label}
          </Typography>
          <Tooltip title="View Screening" placement="top">
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={34}
              height={34}
              sx={{ ml: 1 }}
            >
              <img
                width={13}
                height={14}
                src={ReviewOtpIcon}
                alt="details"
                style={{ marginTop: '-10px', ...cursorPointerStyle }}
              />
            </Box>
          </Tooltip>
        </Box>
      </Stack>
      );
    });
  };
  return (
    <Modal
      open={open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      BackdropProps={{
        invisible: false,
      }}
      disableEscapeKeyDown
      disableAutoFocus={true}
    >
      <Card id="" sx={style}>
        <Grid container width="100%" display="flex" justifyContent="center">
          <Grid item xs={12} display="flex" justifyContent="center">
            <Typography
              sx={{
                fontFamily: 'Work Sans !important',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '18px !important',
                lineHeight: '21px !important',
                color: '#14142B',
              }}
            >
              View Screening Reports
            </Typography>
          </Grid>
        </Grid>
        <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
          <img src={CancelIcon} alt="close" style={{ cursor: 'pointer' }} onClick={onClose} />
        </Grid>

        <Typography
          sx={{
            marginTop: '20px',
            fontFamily: 'Work Sans !important',
            fontStyle: 'normal',
            fontSize: '16px !important',
            lineHeight: '21px !important',
            color: '#14142B',
            fontWeight: 600,
          }}
        >
          {applicantName}:
        </Typography>
        <List style={{ marginTop: '10px' }}>
          {applicantScreeningOrders.map((order) => {
            return renderScreeningProductItem(order);
          })}
        </List>
      </Card>
    </Modal>
  );
};
